import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { type RestoreAccount, type SourceAccount, AccountState, type Account, Provider, CloudAccountType } from '@repo/api-gw-sdk';
import semver from 'semver';
import { getDocsUrl } from '@/docs/docsUrls';
import { getAccountProvider, getAccountState, getAccountType } from '@/utils/accounts';
import { getAccountInstalledVersion, getAccountLatestVersion, isAccountRoleMajorMinorVersionOld } from '@/utils/roles';
import { Icon } from '../shared/icon';
import { ReadMoreLink } from '../shared/readMoreLink';
interface ChangelogKeys {
  source: Parameters<typeof getDocsUrl>[0];
  restore: Parameters<typeof getDocsUrl>[0];
}
const changelogKeyMap: Partial<Record<Provider, ChangelogKeys>> = {
  [Provider.Aws]: {
    source: 'awsSourcePermissionsChangelog',
    restore: 'awsRestorePermissionsChangelog'
  },
  [Provider.Gcp]: {
    source: 'gcpSourcePermissionsChangelog',
    restore: 'gcpRestorePermissionsChangelog'
  },
  [Provider.Azure]: {
    source: 'azureSourcePermissionsChangelog',
    restore: 'azureRestorePermissionsChangelog'
  }
};
export const EonRoleVersion = t0 => {
  const $ = _c(30);
  const {
    account
  } = t0;
  const accountState = getAccountState(account);
  if (accountState === AccountState.ACCOUNT_STATE_INSUFFICIENT_PERMISSIONS) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Typography>--</Typography>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== account) {
    t1 = isAccountRoleMajorMinorVersionOld(account);
    $[1] = account;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const showWarning = t1;
  let T0;
  let T1;
  let changelogUrl;
  let latestVersion;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] !== account) {
    const installedVersion = getAccountInstalledVersion(account);
    latestVersion = getAccountLatestVersion(account);
    const provider = getAccountProvider(account);
    const accountTypeKey = getAccountType(account) === CloudAccountType.Source ? "source" : "restore";
    const docsKey = changelogKeyMap[provider]?.[accountTypeKey];
    let t7;
    if ($[13] !== docsKey) {
      t7 = docsKey ? getDocsUrl(docsKey) : undefined;
      $[13] = docsKey;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    changelogUrl = t7;
    T1 = Stack;
    t4 = "row";
    t5 = "center";
    t6 = "12px";
    T0 = Typography;
    t2 = "inline-block";
    t3 = installedVersion && semver.valid(installedVersion) ? installedVersion : "1.0.0";
    $[3] = account;
    $[4] = T0;
    $[5] = T1;
    $[6] = changelogUrl;
    $[7] = latestVersion;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    T0 = $[4];
    T1 = $[5];
    changelogUrl = $[6];
    latestVersion = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
  }
  let t7;
  if ($[15] !== T0 || $[16] !== t2 || $[17] !== t3) {
    t7 = <T0 className={t2}>{t3}</T0>;
    $[15] = T0;
    $[16] = t2;
    $[17] = t3;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== changelogUrl || $[20] !== latestVersion || $[21] !== showWarning) {
    t8 = showWarning && <Tooltip disableInteractive={false} title={<Stack gap="4px"><Box component="span">v{latestVersion} is available. Upgrade permissions to enable Eon's latest features.</Box>{changelogUrl && <ReadMoreLink text="Go to the changelog" href={changelogUrl} className="text-[inherit]!" />}</Stack>}><Icon iconClass="material-symbols-error-outline-rounded h-[20px] w-[20px]" /></Tooltip>;
    $[19] = changelogUrl;
    $[20] = latestVersion;
    $[21] = showWarning;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== T1 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t9 = <T1 direction={t4} alignItems={t5} gap={t6}>{t7}{t8}</T1>;
    $[23] = T1;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
};